module.exports = __webpack_public_path__ + "media/images/flag/id-c8555cdaea0dcd0599420bbb4909d210.jpg";